// eslint-disable-next-line zillow/import/no-unresolved
import type { Property } from '@zillow/pongo';

const shouldShowContactAgentForm = (
    property: Partial<Property>,
    abTests: { SHOW_PL_LEAD_FORM?: string }
): boolean => {
    const { homeStatus, homeType, isInstantOfferEnabled, zillowOfferMarket } = property;
    const { SHOW_PL_LEAD_FORM } = abTests;
    const selectedHomeType = ['APARTMENT', 'MULTI_FAMILY', 'CONDO', 'TOWNHOUSE', 'SINGLE_FAMILY'];
    const selectedMarket = [
        'CLT',
        'RDU',
        'ATL',
        'PHX',
        'TUS',
        'RIV',
        'ORL',
        'SAN',
        'SMF',
        'LAO',
        'PDX',
        'AUS',
        'SAT',
    ];

    return (
        homeStatus === 'OTHER' &&
        selectedHomeType.includes(homeType as string) &&
        selectedMarket.includes(zillowOfferMarket?.code as string) &&
        !isInstantOfferEnabled &&
        SHOW_PL_LEAD_FORM === 'ON'
    );
};

export default shouldShowContactAgentForm;
